import { render, staticRenderFns } from "./ComplexBackgroundXS.vue?vue&type=template&id=abf283a4&scoped=true"
import script from "./ComplexBackgroundXS.vue?vue&type=script&lang=ts"
export * from "./ComplexBackgroundXS.vue?vue&type=script&lang=ts"
import style0 from "./ComplexBackgroundXS.vue?vue&type=style&index=0&id=abf283a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf283a4",
  null
  
)

export default component.exports